// @todo mobile drag
//
import gsap from "gsap";
const createInputEvents = require("simple-input-events");
import * as THREE from "three";

class Explore {
  constructor() {
    this.mobile = window.isMobile;
    this.event = createInputEvents();
    this.listOpen = false;
    this.time = 0;
    this.speed = 10;
    this.resize();
    this.mouse = new THREE.Vector2();
    this.canvas = document.querySelector(".projects-canvas");
    this.preview = document.querySelector(".projects-list-preview");
    this.mouseTarget = new THREE.Vector2();
    this.currentPosition = new THREE.Vector2(0, 0);
    this.targetPosition = new THREE.Vector2(0, 0);
    this.touchDown = new THREE.Vector2(0, 0);
    this.touch = new THREE.Vector2(0, 0);
    this.onScreen = new THREE.Vector2(0, 0);
    this.onScreenTarget = new THREE.Vector2(0, 0);
    this.distanceFromCenter = 0;

    if(!this.mobile) this.initListPreview();
    this.events();
    this.raf();
  }

  initListPreview() {
    let triggerels = [
      ...document.querySelector(".projects-list").querySelectorAll("tr"),
    ];
    this.pairs = [];
    triggerels.forEach((el, i) => {
      let img = el.querySelector("img");
      if (img) {
        let newimg = img.cloneNode()
        this.preview.appendChild(newimg);
        newimg.style.opacity = 0;
        this.pairs.push({ trigger: el, target: newimg });
      }
      if (el.getAttribute("data-href")) {
        el.addEventListener("click", () => {
          window.location.href = el.getAttribute("data-href");
        });
      }
    });

    this.pairs.forEach((o) => {
      let trigger = o.trigger;
      let target = o.target;

      trigger.addEventListener("mouseenter", () => {
        gsap.fromTo(
          target,
          {
            autoAlpha: 0,
            scale: 1.04,
          },
          {
            duration: 0.3,
            autoAlpha: 1,
            scale: 1,
            overwrite: true,
            ease: "power2.out",
          }
        );
      });
      trigger.addEventListener("mouseleave", () => {
        gsap.to(target, {
          duration: 0.3,
          autoAlpha: 0,
          scale: 1.04,
          ease: "power2.out",
        });
      });
    });

    // trigger popup

    
  }

  resize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
  }

  events() {
    this.event.on("move", ({ uv, dragging, position }) => {
      this.mouse.x = -(uv[0] - 0.5);
      this.mouse.y = -(uv[1] - 0.5);
      this.distanceFromCenter = this.mouse.length() ** 2;

      this.onScreenTarget.x = position[0];
      this.onScreenTarget.y = position[1];

      if (dragging) {
        this.targetPosition.y -= 100 * (this.mouse.y - this.touchDown.y);
        this.targetPosition.x -= 100 * (this.mouse.x - this.touchDown.x);
        // console.log(this.mouse.x - this.touchDown.x, "xxx");

        this.touchDown.x = -(uv[0] - 0.5);
        this.touchDown.y = -(uv[1] - 0.5);
      }
    });

    this.event.on("down", ({ position, uv }) => {
      this.touchDown.x = -(uv[0] - 0.5);
      this.touchDown.y = -(uv[1] - 0.5);
    });

    let popupTriggers = [
      ...document.querySelector(".js-fixed").querySelectorAll("a"),
    ];
    popupTriggers.forEach((el) => {
      el.addEventListener("click", (e) => {
        // e.preventDefault();
        document.dispatchEvent(
          new CustomEvent("projects-toggle", { detail: { open: true } })
        );
      });
    });

    document
      .querySelector(".js-close-projects")
      .addEventListener("click", () => {
        document.dispatchEvent(
          new CustomEvent("projects-toggle", { detail: { open: false } })
        );
      });

    let projectspreview = document.querySelector(".projects");
    document.addEventListener("projects-toggle", (e) => {
      if(e.detail.open){
        this.listOpen = true;
        gsap.to(projectspreview, {
          autoAlpha: 1,
          duration: 0.3,
        });
      } else{
        this.listOpen = false;
        gsap.to(projectspreview, {
          autoAlpha: 0,
          duration: 0.3,
        });
      }
      
    });

    window.addEventListener("resize", this.resize.bind(this));
  }

  raf() {
    this.time += 0.05;
    this.mouseTarget.lerp(this.mouse, 0.1);
    if (!this.mobile) {
      this.currentPosition.add(
        this.mouseTarget.normalize().multiplyScalar(this.distanceFromCenter)
      );
    } else {
      this.currentPosition.lerp(this.targetPosition, 0.05);
    }

    this.onScreen.lerp(this.onScreenTarget, 0.1);
    this.preview.style.transform = `translate3d(${this.onScreen.x}px, ${this.onScreen.y}px, 0)`;

    this.currentPosition.clamp(
      new THREE.Vector2(-this.width / this.speed, -this.height / this.speed),
      new THREE.Vector2(this.width / this.speed, this.height / this.speed)
    );
    this.canvas.style.transform = `translate3d(${
      this.currentPosition.x * this.speed
    }px, ${this.currentPosition.y * this.speed}px, 0)`;
    requestAnimationFrame(this.raf.bind(this));
  }
}

if (document.querySelector(".projects-grid")) new Explore();
